export const CREATE_ORDER_DATA_REQUEST = 'CREATE_ORDER_DATA_REQUEST';
export const CREATE_ORDER_DATA_SUCCESS = 'CREATE_ORDER_DATA_SUCCESS';
export const CREATE_ORDER_DATA_FAILURE = 'CREATE_ORDER_DATA_FAILURE';
export const CREATE_ORDER_DATA_RESET = 'CREATE_ORDER_DATA_RESET';
export const createOrderDataSuccess = (payload) => ({
    type: CREATE_ORDER_DATA_SUCCESS,
    payload,
});
export const createOrderDataRequest = (payload) => ({
    type: CREATE_ORDER_DATA_REQUEST,
    payload,
});
export const createOrderDataReset = () => ({
    type: CREATE_ORDER_DATA_RESET,
});
export const createOrderDataFailure = (payload) => ({
    type: CREATE_ORDER_DATA_FAILURE,
    payload,
});
